import type { Capability } from "owa-capabilities";
import type { MailboxInfo } from "owa-client-types";
import { RegisterForAccountStateChange } from "owa-account-source-list";
import { type AccountSource } from "owa-account-source-list-store";
import { isAccountFeatureEnabled, isGlobalFeatureEnabled } from "owa-feature-flags";
import { areAnyAccountsEnterpriseOrPremiumConsumer } from "./utils/areAnyAccountsEnterpriseOrPremiumConsumer";
import { isLocalDataBackedMailboxInfo } from "owa-account-source-list/lib/utils/isLocalDataBackedAccount";

let checked = false;
let enabled = false;

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 *
 * This capability is being used to determine if mail can be saved
 */
export const saveEmailAsMSGToFileCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        if (!isGlobalFeatureEnabled("doc-saveAs-EML-MSG-premiumOnly")) {
            return true; // Flag off: old behavior, everyone can save
        }
        
        if (checked) {
            return enabled;
        }
        
        enabled = areAnyAccountsEnterpriseOrPremiumConsumer();
        checked = true;
        
        RegisterForAccountStateChange(onAccountsChanged, onAccountsChanged);
        
        return enabled;
    },
    isSupported: (mailboxInfo?: MailboxInfo) => {
        // Check doc-saveAs-EML-MSG and acct-pstFileImportExport feature flag only for PST mailboxInfo
        return (isGlobalFeatureEnabled("doc-saveAs-EML-MSG") &&
            (mailboxInfo && isLocalDataBackedMailboxInfo(mailboxInfo)
                ? isAccountFeatureEnabled("acct-pstFileImportExport", mailboxInfo)
                : true));
    },
};

// Callback for when an account is added or removed
const onAccountsChanged = async (_accountSource: AccountSource) => {
    enabled = areAnyAccountsEnterpriseOrPremiumConsumer();
};
